import React, { useState } from "react";
import Utilities from "../../../lib/Utilities";
import { useTranslation } from "react-i18next";

const util = new Utilities();
const today = new Date();
export default React.memo(ChatNewsItem);

function ChatNewsItem(props) {
  const {
    searchText,
    item,
    openNewsChatRoom,
    actionSubscribe,
    alertDisabledList,
    updateAlertDisable,
  } = props;
  const { t } = useTranslation();
  const [isOpenMenu, setIsOpenMenu] = useState(false);

  let isDisplay = true;
  if (searchText !== "" && item.cnmName.indexOf(searchText) === -1) {
    isDisplay = false;
  }

  const pic =
    item.COMP_LOGO !== ""
      ? item.COMP_LOGO.split("?")[0]
      : "https://freiscop.gbts.co.kr/images/user_pic-50x50.png";
  const unread = Number(item.cnmUnreadCnt);

  let displayTime = "";
  let cnmLastTime = new Date(item.cnmLastTime);

  if (
    util.getDateToFormat(today, "YYYY.MM.DD") ===
    util.getDateToFormat(cnmLastTime, "YYYY.MM.DD")
  ) {
    let condition = t("logiTalk.chatList.am");
    let hour = cnmLastTime.getHours();
    if (hour > 12) {
      condition = t("logiTalk.chatList.pm");
      hour = hour - 12;
    }
    displayTime = `${condition} ${hour}:${cnmLastTime.getMinutes()}`;
  } else {
    displayTime = util.getDateToFormat(cnmLastTime, "YYYY.MM.DD");
  }

  return (
    <div
      className={`${
        isDisplay ? "d-flex" : "d-none"
      }  flex-row justify-content-start align-items-center cursor_pointer cursor_pointer_bg_light position-relative py-2 px-3`}
    >
      <div
        className="flex-fill d-flex flex-row align-items-center"
        onClick={() => openNewsChatRoom(item)}
      >
        <div
          className="position-relative d-flex flex-row align-items-center justify-content-center flex-wrap mr-1"
          style={{ width: 50, height: 50 }}
        >
          <div
            className="w-100 h-100 border"
            style={{
              background: `url(${pic}) #fff 50% 50% / contain no-repeat`,
              width: 50,
              height: 50,
              borderRadius: "45%",
            }}
          />
        </div>
        <div className="pl-2 flex-grow-1">
          <div className="d-flex flex-row  align-items-center">
            <div className="font-weight-bold m-0 p-0 d-flex flex-row justify-content-start">
              <div className="text-truncate" style={{ maxWidth: 250 }}>
                {item.cnmName}
                {alertDisabledList.hasOwnProperty(item.cnmMainKey) && (
                  <i
                    className="far fa-bell-slash ml-2 text-danger"
                    style={{ minWidth: 20 }}
                  />
                )}
              </div>
            </div>
          </div>
          <p
            className="m-0"
            style={{
              maxWidth: 200,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              wordBreak: "keep-all",
            }}
          >
            {item.cnmDesc}
          </p>

          <p className="m-0 font-size-08">{displayTime}</p>
        </div>
      </div>
      <div className="align-self-start position-relative">
        <i
          className="fa-solid fa-ellipsis-vertical cursor_pointer px-1"
          onClick={() => setIsOpenMenu(true)}
        />
        {isOpenMenu && (
          <>
            <div
              className="position-absolute bg-white rounded shadow-sm overflow-hidden"
              style={{ minWidth: 120, zIndex: 4, top: 0, right: 0 }}
            >
              <p
                className="p-2 cursor_pointer cursor_pointer_bg_light transition-1"
                onClick={() => {
                  const type = alertDisabledList.hasOwnProperty(item.cnmMainKey)
                    ? "DELETE"
                    : "INSERT";
                  updateAlertDisable(type, {
                    ...item,
                    crmMainKey: item.cnmMainKey,
                  });
                  setIsOpenMenu(false);
                }}
              >
                {t("logiTalk.chatList.alarm")}{" "}
                {alertDisabledList.hasOwnProperty(item.cnmMainKey)
                  ? t("logiTalk.chatList.on")
                  : t("logiTalk.chatList.off")}
              </p>
              {/*구독 알림톡만 구독해제 가능*/}
              {item.cnmType === "3" && (
                <p
                  className="p-2 cursor_pointer cursor_pointer_bg_light transition-1"
                  onClick={() => actionSubscribe(item)}
                >
                  {t("logiTalk.chatList.unsubscribe")}
                </p>
              )}
            </div>
            <div
              className="vw-100 vh-100 position-fixed cursor_pointer"
              style={{
                top: 0,
                left: 0,
                zIndex: 3,
                background: "rgba(0,0,0,0.1)",
              }}
              onClick={() => setIsOpenMenu(false)}
            />
          </>
        )}
      </div>

      {unread > 0 && (
        <div
          className="d-inline-block rounded-circle position-absolute d-flex flex-row justify-content-center align-items-center font-weight-bold bg-info text-white font-size-07"
          style={{
            width: 16,
            height: 16,
            right: "0.85rem",
            bottom: "0.85rem",
          }}
        >
          {unread > 9 ? `+9` : unread}
        </div>
      )}
    </div>
  );
}
